import { EnumRateType } from "#/constants";
import type { TExamQuestionsForResultSet } from "#/services/rest/gwt/exam-results/descriptive/exam-question-result-set.types";
import { postRateInsert } from "#/services/rest/gwt/exam-results/submit-rate/submit-rate.api";
import { errorToastOption } from "@monta/components";
import { Toast } from "@monta/design-system";
import clsx from "clsx";
import { useState } from "react";
import StarRatings from "react-star-ratings";
import styles from "./answer.module.scss";

type Props = {
  answerRate?: TExamQuestionsForResultSet["answerRate"];
  id: TExamQuestionsForResultSet["id"];
};
const Rate = (props: Props) => {
  const { answerRate, id = "" } = props;

  const [stars, setStars] = useState(answerRate ?? 0);

  const { mutate: rateInsertMutate } = postRateInsert.useMutation({
    onSuccess: (result, variables) => {
      if (result.resultCode > 0) {
        Toast.success({
          message: "نظر شما با موفقیت ثبت شد",
        });
        setStars(variables.body.rate);
      } else {
        Toast.error(errorToastOption);
        setStars(0);
      }
    },
    onError: () => {
      setStars(0);
      Toast.error(errorToastOption);
    },
  });

  return (
    <div className={styles["rate"]}>
      <div className={styles["rate__title"]}>
        میزان رضایت شما از کیفیت پاسخ:
      </div>

      <div className={clsx(styles["rate__container"])}>
        <StarRatings
          rating={stars}
          starDimension="30px"
          starRatedColor="#F2C94C"
          starEmptyColor="#E0E0E0"
          starHoverColor="#F2C94C"
          starSpacing={"4px"}
          numberOfStars={5}
          changeRating={(e) => {
            rateInsertMutate({
              body: {
                rate: e,
                referenceId: Number(id),
                referenceTypeId: EnumRateType.QUESTION_ANSWER,
              },
            });
          }}
          name="rating"
        />
      </div>
    </div>
  );
};
export default Rate;
